<template>
  <div data-component="CsSkeleton" :class="classes" />
</template>

<script>
import { tv } from 'tailwind-variants';

const skeleton = tv({
  base: [
    'group relative overflow-hidden animate-pulse',
    'before:opacity-100 before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer',
    'before:bg-[linear-gradient(90deg,transparent_0%,var(--shimmer-color)_50%,transparent_100%)]',
    'after:opacity-100 after:absolute after:inset-0 after:-z-10 transition-background duration-300 before:transition-opacity',
  ],
  variants: {
    variantColor: {
      neutral: [
        'bg-slate-200 dark:bg-neutral-dark [--shimmer-color:theme(colors.slate.300/0.7)]',
        'dark:[--shimmer-color:theme(colors.slate.700/0.5)]',
        'after:bg-slate-200 dark:after:bg-neutral-dark',
      ],
      blue: [
        'bg-woot-100/70 dark:bg-woot-700/50 [--shimmer-color:theme(colors.woot.400/0.7)]',
        'dark:[--shimmer-color:theme(colors.woot.800/0.8)]',
        'after:bg-woot-100/70 dark:after:bg-woot-700/70',
      ],
    },
  },
});

export default {
  name: 'CsSkeleton',
  props: {
    variantColor: {
      type: String,
      default: 'neutral',
    },
  },
  computed: {
    classes() {
      return skeleton({
        variantColor: this.variantColor,
      });
    },
  },
};
</script>
